/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Waveform_Timeout_MessageInputs */

const en_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If this takes longer than a minute please use the legacy timeline`)
};

const fr_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si cela prend plus d'une minute, veuillez utiliser la chronologie heritee`)
};

const de_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falls dies länger als eine Minute dauert, verwenden Sie bitte die ältere Zeitleiste.`)
};

const it_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se l'operazione richiede più di un minuto, utilizzare la cronologia precedente`)
};

const ru_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если это займет больше минуты, пожалуйста, воспользуйтесь старой временной шкалой.`)
};

const es_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si esto toma más de un minuto, utilice la línea de tiempo heredada`)
};

const zh_cn2_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果耗时超过一分钟，请使用旧版时间线`)
};

const ja_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分以上かかる場合は、従来のタイムラインを使用してください。`)
};

const hi_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि इसमें एक मिनट से अधिक समय लगता है तो कृपया पुरानी टाइमलाइन का उपयोग करें।`)
};

const pt_pt2_timeline_waveform_timeout_message = /** @type {(inputs: Timeline_Waveform_Timeout_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se isso demorar mais de um minuto, use a linha do tempo antiga.`)
};

/**
* | output |
* | --- |
* | "If this takes longer than a minute please use the legacy timeline" |
*
* @param {Timeline_Waveform_Timeout_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_waveform_timeout_message = /** @type {((inputs?: Timeline_Waveform_Timeout_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Waveform_Timeout_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_waveform_timeout_message(inputs)
	if (locale === "de") return de_timeline_waveform_timeout_message(inputs)
	if (locale === "it") return it_timeline_waveform_timeout_message(inputs)
	if (locale === "ru") return ru_timeline_waveform_timeout_message(inputs)
	if (locale === "es") return es_timeline_waveform_timeout_message(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_waveform_timeout_message(inputs)
	if (locale === "ja") return ja_timeline_waveform_timeout_message(inputs)
	if (locale === "hi") return hi_timeline_waveform_timeout_message(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_waveform_timeout_message(inputs)
	return en_timeline_waveform_timeout_message(inputs)
});